module.exports = __webpack_public_path__ + "img/underline.fcfd4c46.svg";